import React, { useState, useEffect } from 'react';
import '../Css_files/contact_1.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    company: '',
    service: '',
    budget: '',
    message: ''
  });

  const [isVisible, setIsVisible] = useState({});
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        access_key: "44e66b8b-faf0-4800-bb72-cd3b60680452",
        subject: "Profenaa Technologies - New Contact Form Submission",
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        company: formData.company,
        service: formData.service,
        budget: formData.budget,
        subject_line: formData.subject,
        message: formData.message,
      }),
    })
      .then((res) => {
        if (res.ok) {
          alert("Your message has been sent successfully!");
          setFormData({
            name: '',
            email: '',
            phone: '',
            company: '',
            service: '',
            budget: '',
            message: ''
          });
        } else {
          alert("Something went wrong. Please try again.");
        }
      })
      .catch((err) => {
        console.error("Error submitting the form:", err);
        alert("Error submitting the form.");
      });
  };

  const contactInfo = [
    {
      icon: '📞',
      title: 'Call Us',
      details: ['+91 9944897638', '+91 9698730528', 'Mon-Fri 10AM-8PM'],
      color: '#4ECDC4'
    },
    {
      icon: '✉️',
      title: 'Email Us',
      details: ['profenaa.cbe@gmail.com', 'support@company.com', 'careers@company.com'],
      color: '#45B7D1'
    },
    {
      icon: '🌐',
      title: 'Follow Us',
      details: ['Facebook: Profenaatechnologies', 'LinkedIn: Profenaatechnologies', 'Instagram: profenaacoimbatore'],

      color: '#96CEB4'
    }
  ];

  return (
    <div className="contact-container">
      <div className="animated-background">
        <div className="floating-shapes">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="floating-shape"
              style={{
                '--delay': `${i * 0.5}s`,
                '--duration': `${8 + (i % 4)}s`,
                '--size': `${20 + (i % 30)}px`
              }}
            />
          ))}
        </div>

        <div 
          className="mouse-follower"
          style={{
            left: mousePosition.x,
            top: mousePosition.y
          }}
        />
      </div>

      <section className="contact-hero">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="title-word">Get</span>
            <span className="title-word">In</span>
            <span className="title-word">Touch</span>
          </h1>
          <p className="hero-subtitle">
            We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
          <div className="hero-decoration">
            <div className="pulse-ring"></div>
            <div className="pulse-ring"></div>
            <div className="pulse-ring"></div>
          </div>
        </div>
      </section>

      <section className="contact-info-section">
        <div className="info-grid">
          {contactInfo.map((info, index) => (
            <div
              key={index}
              className="info-card"
              style={{
                '--delay': `${index * 0.2}s`,
                '--accent-color': info.color
              }}
            >
              <div className="card-icon">{info.icon}</div>
              <h3 className="card-title">{info.title}</h3>
              <div className="card-details">
                {info.details.map((detail, i) => (
                  <p key={i} className="detail-item">{detail}</p>
                ))}
              </div>
              <div className="card-glow"></div>
            </div>
          ))}
        </div>
      </section>

      <section className="main-content">
        <div className="content-grid">
          <div className="form-section">
            <div className="form-header">
              <h2 className="section-title">Send us a Message</h2>
              <p className="section-subtitle">
                Fill out the form below and we'll get back to you within 24 hours
              </p>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="input-group">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="form-input"
                  />
                  <label className="form-label">Full Name</label>
                  <div className="input-highlight"></div>
                </div>

                <div className="input-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="form-input"
                  />
                  <label className="form-label">Email Address</label>
                  <div className="input-highlight"></div>
                </div>
              </div>

              <div className="form-row">
                <div className="input-group">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="form-input"
                  />
                  <label className="form-label">Phone Number</label>
                  <div className="input-highlight"></div>
                </div>

                <div className="input-group">
                  <input
                    type="text"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    className="form-input"
                  />
                  <label className="form-label">Currently Woking / Student</label>
                  <div className="input-highlight"></div>
                </div>
              </div>

              <div className="form-row">
                <div className="input-group">
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    className="form-input form-select"
                  >
                    <option value="">Select Service</option>
                    <option value="Mechanical">Mechanical</option>
                    <option value="Civil">Civil</option>
                    <option value="Ece">Ece</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Computer Science">Computer Science</option>
                    <option value="Arts & Multimedia">Arts & Multimedia</option>
                  </select>
                  <label className="form-label">Courses Provided</label>
                  <div className="input-highlight"></div>
                </div>

                <div className="input-group">
                  <select
                    name="budget"
                    value={formData.budget}
                    onChange={handleInputChange}
                    className="form-input form-select"
                  >
                    <option value="Mode of Course">Mode of Course</option>
                    <option value="Online">Online</option>
                    <option value="Offline">Offline</option>
                    <option value="Internship">Internship</option>
                  </select>
                  <label className="form-label">Mode of Course</label>
                  <div className="input-highlight"></div>
                </div>
              </div>



              <div className="input-group">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  className="form-textarea"
                  rows="4"
                ></textarea>
                <label className="form-label">Your Message</label>
                <div className="input-highlight"></div>
              </div>

              <div className="form-footer">
                <div className="form-info">
                  <p className="info-text">
                    <span className="info-icon">🔒</span>
                    Your information is secure and will never be shared
                  </p>
                  <p className="info-text">
                    <span className="info-icon">⚡</span>
                    We typically respond within 12 hours during business hours
                  </p>
                </div>
                
                <button type="submit" className="submit-btn">
                  <span className="btn-text">Send Message</span>
                  <span className="btn-icon">🚀</span>
                  <div className="btn-ripple"></div>
                </button>
              </div>
            </form>
          </div>

          <div className="map-section">
            <div className="map-container">
              <div className="map-header">
                <h3 className="map-title">Find Us Here</h3>
                <p className="map-subtitle">Visit our office for a face-to-face meeting</p>
              </div>

              <div className="map-wrapper">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31367.665614906753!2d76.9849161347656!3d10.660352400000008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8399b19bfb357%3A0xc8329c8853d2ed87!2sPROFENAA%20TECHNOLOGIES%20(E-CADD%20CENTRE)%7CMECH%2CCIVIL%2CEEE%2FECE%2CCSE%2FIT%20%26%20ARTS%20MULTIMEDIA%20%7C%20AI%20%26%20DATA%20SCIENCE%20%2C%20TRAINING%20%26%20PLACEMENTS!5e0!3m2!1sen!2sin!4v1753537173759!5m2!1sen!2sin"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Office Location"
                ></iframe>
                <div className="map-overlay">
                  <div className="location-pin">📍</div>
                </div>
              </div>
            </div>

            <div className="quick-contact">
              <h3 className="quick-title">Quick Contact</h3>
              <div className="quick-items">
                <div className="quick-item">
                  <span className="quick-icon">⚡</span>
                  <span className="quick-text">24/7 Support Available</span>
                </div>
                <div className="quick-item">
                  <span className="quick-icon">🎯</span>
                  <span className="quick-text">Response within 12 hours</span>
                </div>
                <div className="quick-item">
                  <span className="quick-icon">🔒</span>
                  <span className="quick-text">Your data is secure</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
